import AdminList from '@/views/admin/AdminList.vue';
import { UserOutlined } from '@ant-design/icons-vue';

export const adminRoutes = [
    {
        path: 'admin-list',
        component: AdminList,
        name: 'AdminList',
        meta: {
            title: '管理員列表',
            icon: UserOutlined
        }
    }
];
